import './AppNumber.scss'
import { TextField } from '@mui/material';
import { matTextNumberStyle } from '../../assets/style/material/matSyles';

interface Props {
    label: string,
    inputProps: any,
    defaultValue: number,
    handleOnChange?: any,
    id?: number,
    disabled?: boolean
}

export default function AppNumber({label, inputProps, defaultValue, handleOnChange, id, disabled}: Props) {

    const textNumberStyle = matTextNumberStyle();
    const styleClass = `${textNumberStyle.textField} ${textNumberStyle.textFieldAppNumber}`
    return (
        <TextField
            id={id?.toString()}
            className={styleClass}
            label={label}
            type="number"
            value={defaultValue}
            InputLabelProps={{className: textNumberStyle.textFieldLabel}}
            InputProps={inputProps}
            onChange={handleOnChange}
            disabled={disabled}
        />
    )
}